import { render, staticRenderFns } from "./BarScanner.vue?vue&type=template&id=149be378&scoped=true&"
import script from "./BarScanner.vue?vue&type=script&lang=js&"
export * from "./BarScanner.vue?vue&type=script&lang=js&"
import style0 from "./BarScanner.vue?vue&type=style&index=0&id=149be378&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149be378",
  null
  
)

export default component.exports